"use strict";

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.array.map");

var _axios = _interopRequireDefault(require("axios"));

var _articleUtils = require("./article-utils");

var _utils = require("../helpers/utils");

var _cssClasses = _interopRequireDefault(require("../helpers/cssClasses"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/**
 * Template: Article
 * ------------------------------------------------------------------------------
 * Gets & displays books under the same series.
 *
 * @namespace ArticleFreeReads
 */


var selectors = {
  relatedBooks: '[role="related-books"]',
  relatedProducts: '[role="related-products"]',
  articleTitle: '[role="title"]',
  loadMoreButton: '[js-next-pagination]',
  mainContent: '#MainContent'
};
var loadMoreBtnTemplate = "\n  <div class=\"loader\">\n    <div class=\"ball-clip-rotate\">\n      <div></div>\n    </div>\n    <span class=\"visually-hidden\">Loading More books</span>\n  </div>\n  <span>Load More</span>";

var _default = function _default() {
  var cache = {
    $relatedBooks: document.querySelector(selectors.relatedBooks),
    $relatedProducts: document.querySelector(selectors.relatedProducts),
    $articleTitle: document.querySelector(selectors.articleTitle),
    $mainContent: document.querySelector(selectors.mainContent)
  };
  var cursor = '';
  var bookSerie = '';

  function setGraphQlCursor(data) {
    var edges = data.edges;
    var edgesLength = edges.length;
    var lasCursor = edges[edgesLength - 1].cursor;
    cursor = "\"".concat(lasCursor, "\"");
  }

  function setButtonLoadingState() {
    cache.$loadMoreButton.classList.add(_cssClasses["default"].loading);
    cache.$loadMoreButton.setAttribute('disabled', 'disabled');
  }

  function removeButtonLoadingState() {
    if (!cache.$loadMoreButton) {
      return;
    }

    cache.$loadMoreButton.classList.remove(_cssClasses["default"].loading);
    cache.$loadMoreButton.removeAttribute('disabled');
  }

  function handleLoadBtnClick(event) {
    var loadMorePagination = parseInt(event.target.getAttribute('js-next-pagination'), 2);
    setButtonLoadingState();
    getCollectionGraphQl(bookSerie, _articleUtils.maxRelatedBooksOnload);
    event.currentTarget.setAttribute('js-next-pagination', loadMorePagination + 1);
  }

  function setClickEvent(loadMoreButton) {
    (0, _utils.on)('click', loadMoreButton, function (event) {
      return handleLoadBtnClick(event);
    });
  }

  function setLoadMoreButton(button) {
    cache.$loadMoreButton = button;
  }

  function removeLoadMoreButton(loadButton) {
    if (loadButton) {
      loadButton.parentNode.remove(loadButton);
    }
  }

  function toggleLoadMoreButton(pageInfo) {
    var relatedProductContainer = cache.$relatedProducts;
    var loadButton = cache.$relatedBooks.querySelector(selectors.loadMoreButton);
    var hasNextPage = pageInfo.hasNextPage;

    if (!hasNextPage) {
      removeLoadMoreButton(loadButton);
      return;
    }

    if (loadButton) {
      return;
    }

    var viewAllContainer = document.createElement('div');
    var loadMoreButton = document.createElement('button');
    viewAllContainer.classList = 'template-article_books_button_container';
    loadMoreButton.classList = 'button button--primary template-article_books_view_all';
    loadMoreButton.setAttribute('js-next-pagination', '2');
    viewAllContainer.appendChild(loadMoreButton);
    loadMoreButton.innerHTML = loadMoreBtnTemplate;
    relatedProductContainer.parentNode.append(viewAllContainer);
    setLoadMoreButton(loadMoreButton);
    setClickEvent(loadMoreButton);
  }

  function setProductImage(image) {
    return image.edges.length === 0 ? _articleUtils.placeholderImage : image.edges[0].node.originalSrc;
  }

  function productTemplate(title, url, productImage, variants) {
    var image = setProductImage(productImage);
    var variantsNode = variants.edges.map(function (item) {
      var _item$node = item.node,
          price = _item$node.price,
          compareAtPrice = _item$node.compareAtPrice;
      var variantTitle = item.node.title;
      return (0, _articleUtils.productCardVariants)(variantTitle, price, compareAtPrice);
    }).join('');
    return "\n      <div class=\"card card--product col s6 m4 l3\">\n        <a class=\"card__link\" href=\"".concat(url, "\">\n          <div class=\"card__thumbnail-container\">\n            <img src=\"").concat(image, "\" />\n          </div>\n        </a>\n        <div class=\"card__footer\">\n          <a class=\"card__link card__title\" href=\"").concat(url, "\">").concat(title, "</a>\n          <div class=\"card__product-item-price\">\n            ").concat(variantsNode, "\n          </div>\n        </div>\n      </div>");
  }

  function renderRelatedProductsGraphQl(data) {
    var pageInfo = data.pageInfo,
        edges = data.edges;
    var productsLength = edges.length;
    var remainingProducts = [];

    if (productsLength > 0) {
      var productsString = edges.map(function (item, index) {
        var _item$node2 = item.node,
            title = _item$node2.title,
            onlineStoreUrl = _item$node2.onlineStoreUrl,
            images = _item$node2.images,
            variants = _item$node2.variants;

        if (index <= _articleUtils.maxRelatedBooksOnload - 1) {
          return productTemplate(title, onlineStoreUrl, images, variants);
        } else {
          remainingProducts.push(item);
        }

        return '';
      }).join('');
      cache.$relatedProducts.insertAdjacentHTML('beforeend', productsString);
      cache.$relatedBooks.classList.remove('hidden');
      cache.$mainContent.style.marginBottom = 0;
      toggleLoadMoreButton(pageInfo);
      return data;
    }

    return data;
  }

  function getCollectionProductsGraphQl(data, pagination) {
    (0, _axios["default"])({
      url: _articleUtils.graphQlUrl,
      method: 'post',
      data: {
        query: (0, _articleUtils.collectionProductsQuery)(data, pagination, cursor)
      },
      headers: {
        'X-Shopify-Storefront-Access-Token': _articleUtils.storefrontAccessToken
      }
    }).then(function (response) {
      if (response.data.errors) {
        (0, _articleUtils.logGraphErrorsArray)(response.data.errors);
        return response;
      }

      setGraphQlCursor(response.data.data.collectionByHandle.products);
      renderRelatedProductsGraphQl(response.data.data.collectionByHandle.products);
      removeButtonLoadingState();
      return response;
    })["catch"](function (error) {
      window.console.error(error);
      return error;
    });
  }

  function getBookSerie(data) {
    var article = data.data.articles.edges.find(function (item) {
      return item.node.tags.find(function (tag) {
        return tag.toLowerCase().includes('series');
      });
    });

    if (!article) {
      return data;
    }

    return article.node.tags.find(function (tag) {
      return tag.toLowerCase().includes('series');
    });
  }

  function getCollectionHandle(data, serie) {
    var collectionEdge = data.find(function (collection) {
      return collection.node.title.toLowerCase() === serie;
    });
    return collectionEdge.node.handle;
  }

  function getCollectionGraphQl(serie) {
    (0, _axios["default"])({
      url: _articleUtils.graphQlUrl,
      method: 'post',
      data: {
        query: (0, _articleUtils.collectionQuery)(serie)
      },
      headers: {
        'X-Shopify-Storefront-Access-Token': _articleUtils.storefrontAccessToken
      }
    }).then(function (response) {
      if (response.data.errors) {
        (0, _articleUtils.logGraphErrorsArray)(response.data.errors);
        return response;
      }

      var edges = response.data.data.collections.edges;
      var collectionHandle = getCollectionHandle(edges, serie);
      getCollectionProductsGraphQl(collectionHandle, _articleUtils.maxRelatedBooksOnload);
      return response;
    })["catch"](function (error) {
      window.console.error(error);
      return error;
    });
  }

  function init() {
    var seriesTitle = cache.$articleTitle.innerHTML.split('-')[0];
    (0, _axios["default"])({
      url: _articleUtils.graphQlUrl,
      method: 'post',
      data: {
        query: (0, _articleUtils.articleQuery)(seriesTitle, _articleUtils.maxRelatedBooksOnload, cursor)
      },
      headers: {
        'X-Shopify-Storefront-Access-Token': _articleUtils.storefrontAccessToken
      }
    }).then(function (response) {
      if (response.data.errors) {
        (0, _articleUtils.logGraphErrorsArray)(response.data.errors);
        return response;
      }

      bookSerie = getBookSerie(response.data).toLowerCase();
      getCollectionGraphQl(bookSerie);
      return response;
    })["catch"](function (error) {
      window.console.error(error);
      return error;
    });
  }

  return Object.freeze({
    init: init
  });
};

exports["default"] = _default;